var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "none",
    stroke: "#FF6600",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svc-sign__legs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331 593 V841 M692 593 V841",
    strokeLinecap: "butt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 841 H432 M592 841 H792"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "svc-sign__panel"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 206,
    width: 765,
    height: 387,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "svc-sign__line-1",
    d: "M212 300 H560"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svc-sign__line-2",
    d: "M212 400 H480"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svc-sign__line-3",
    d: "M212 500 H400"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "svc-sign__img",
    x: 646.5,
    y: 301.5,
    width: 148,
    height: 196.5,
    rx: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignage);
export default __webpack_public_path__ + "static/media/signage.0abbd7ab0cf2d295f37456e30a0ce5aa.svg";
export { ForwardRef as ReactComponent };